import './accessibility.css.js';
import { localize2WithPath } from 'vscode/vscode/vs/nls';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IAccessibilityService } from 'vscode/vscode/vs/platform/accessibility/common/accessibility.service';
import { Action2, registerAction2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { accessibilityHelpIsShown } from 'vscode/vscode/vs/workbench/contrib/accessibility/browser/accessibilityConfiguration';
import { alert } from 'vscode/vscode/vs/base/browser/ui/aria/aria';
import { AccessibilityHelpNLS } from 'vscode/vscode/vs/editor/common/standaloneStrings';

const _moduleId = "vs/workbench/contrib/codeEditor/browser/accessibility/accessibility";
class ToggleScreenReaderMode extends Action2 {
    constructor() {
        super({
            id: 'editor.action.toggleScreenReaderAccessibilityMode',
            title: ( localize2WithPath(_moduleId, 0, "Toggle Screen Reader Accessibility Mode")),
            metadata: {
                description: ( localize2WithPath(
                    _moduleId,
                    1,
                    "Toggles an optimized mode for usage with screen readers, braille devices, and other assistive technologies."
                )),
            },
            f1: true,
            keybinding: [{
                    primary: 2048  | 35 ,
                    weight: 200  + 10,
                    when: accessibilityHelpIsShown
                },
                {
                    primary: 512  | 59  | 1024 ,
                    linux: { primary: 512  | 62  | 1024  },
                    weight: 200  + 10,
                }]
        });
    }
    async run(accessor) {
        const accessibiiltyService = accessor.get(IAccessibilityService);
        const configurationService = accessor.get(IConfigurationService);
        const isScreenReaderOptimized = accessibiiltyService.isScreenReaderOptimized();
        configurationService.updateValue('editor.accessibilitySupport', isScreenReaderOptimized ? 'off' : 'on', 2 );
        alert(isScreenReaderOptimized ? AccessibilityHelpNLS.screenReaderModeDisabled : AccessibilityHelpNLS.screenReaderModeEnabled);
    }
}
registerAction2(ToggleScreenReaderMode);
